import * as THREE from 'three'
import { useGLTF, MeshWobbleMaterial, Text } from '@react-three/drei'
import BillboardHoarding from '../BillboardHoarding'
import { useEffect, useState } from 'react'
import { useBox } from '@react-three/cannon'
import { useModelTransition } from '../../hooks'
import PropTypes from 'prop-types'
const Oddish = ({ page }) => {
  const { nodes, _ } = useGLTF('./libs/oddish/scene.gltf')
  const [isActive, setIsActive] = useState(false)

  const model = {
    position: new THREE.Vector3(-10, 0, 10),
    rotation: new THREE.Vector3(0, Math.PI / 2, 0),
    options: {
      focusOnPosition: new THREE.Vector3(-12, 1.4, 11),
      animateToPosition: new THREE.Vector3(2, 2.4, 5),
      fov: 15,
    },
  }
  const [activateMesh] = useBox(() => ({
    args: [4, 4, 0.05],
    rotation: [-Math.PI / 2, 0, 0],
    position: [model.position.x, 0.001, model.position.z],
  }))
  useEffect(
    () => (page === 'resume' ? setIsActive(true) : setIsActive(false)),
    [page]
  )

  useEffect(() => {
    activateMesh.current.name = 'activitymesh.resume'
  }, [])
  useModelTransition(isActive, model.options)

  return (
    <group>
      <Text
        color="#212121"
        position={[model.position.x + 1.2, 1.5, model.position.z + 1.2]}
        fontSize={0.2}
        letterSpacing={0.2}
        fillOpacity={0}
        outlineColor="#212121"
        outlineWidth={0.01}
        rotation={[
          model.rotation.x,
          model.rotation.y + Math.PI / 2,
          model.rotation.z,
        ]}
      >
        Resume
      </Text>
      <BillboardHoarding
        position={[model.position.x + 1, 0, model.position.z + 1.4]}
        scale={0.2}
        rotation={[
          model.rotation.x,
          model.rotation.y + Math.PI / 2,
          model.rotation.z,
        ]}
      />
      <mesh ref={activateMesh} />
      <mesh position={[...model.position]} rotation={[...model.rotation]}>
        <boxBufferGeometry args={[1.6, 0.5, 1.6]} />
        <meshStandardMaterial color="white" />
      </mesh>
      <group
        position={[model.position.x, 0.8, model.position.z]}
        rotation={[...model.rotation]}
        dispose={null}
      >
        <group rotation={[-Math.PI / 2, 0, 0]} scale={0.2}>
          <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
            <group rotation={[-Math.PI / 2, 0, 0]} scale={100}>
              <mesh
                geometry={nodes.Oddish002_Oddish_0.geometry}
                material={nodes.Oddish002_Oddish_0.material}
              />
              <mesh geometry={nodes.Oddish002_Oddish_0001.geometry}>
                <MeshWobbleMaterial
                  factor={0.4}
                  color="#8bc34a"
                  // map={nodes.Oddish002_Oddish_0001.material}
                />
              </mesh>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}
Oddish.defaultProps = {
  page: '',
}

Oddish.propTypes = {
  page: PropTypes.string,
}

useGLTF.preload('./libs/oddish/scene.gltf')

export default Oddish
